import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilitiesService } from './../../../shared/services/utilities.service';
import { Component, OnInit } from '@angular/core';
import { Dispersion } from 'src/app/shared/models/dispersions';
import { DispersionsService } from 'src/app/shared/services/dispersions.service';
import { MomentService } from 'src/app/shared/services/moment.service';
import { Level } from '../../../shared/enums/level.enum';

@Component({
  selector: 'app-dispersion-pending',
  templateUrl: './dispersion-pending.component.html',
  styleUrls: ['./dispersion-pending.component.scss']
})
export class DispersionPendingComponent implements OnInit {
  private _subscriptions: Subscription[] = [];
  public dispersions: Dispersion[];
  public cdta: any;
  public usdt: any;
  public id_companies_list: any[] = [];

  constructor(
    private dispesrionsService: DispersionsService,
    private utilitiesService: UtilitiesService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    
  }

  ngOnInit() {
    this.cdta = this.utilitiesService.getCompanyData();
    this.usdt = this.utilitiesService.getUserData();
    this.getDispersions();
  }

  getDispersions() {
    switch (this.usdt.level) {
      case Level.ihunterSuperUser:
      case Level.ihunterAdmin:
      case Level.ihunterReportes:
      case Level.CompanyAdmin:
      case Level.CompanyUser:
        this._subscriptions.push(
          this.dispesrionsService.getDispersions().subscribe(dispersions => {
            this.dispersions = dispersions.filter(dispersion => dispersion.status <= 2);     
          })
        );
        break;
      case Level.Broker:
        this._subscriptions.push(
          this.dispesrionsService.getDispersions().subscribe(dispersions => {
            this.dispersions = dispersions;
            if (this.usdt.companyList) {
              this.usdt.companyList.forEach(company => {
                this.id_companies_list.push(company.id.trim());
              });
            }
            this.dispersions = dispersions.filter(dispersion => dispersion.status <= 2 && this.id_companies_list.includes(dispersion.companyId));
          })
        );
        break;
      default:
        break;
    }
  }

  newDispersion() {
    this.router.navigate(['/dash/dispersions/new/']);
  }
  viewDetail(id) {
    this.router.navigate(['/detail/' + id], {
      relativeTo: this.route
    });
  }

  
  deleteDispersion(id){
    this.dispesrionsService.deleteDispersion(id).then(data => {
      this.utilitiesService.notifyMe('Ha sido eliminado', 'success');
    });
  }


  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }
}
